import React from 'react'

import { Player } from 'video-react'

import {
    EuiText,
    EuiIcon,
    EuiPanel
  } from '@elastic/eui'

import { OutboundLink } from 'gatsby-plugin-gtag'

require('../../../Layout/chrome/assets/video.css')

function VideoCard() {
  return (
    <EuiPanel paddingSize="m">
        <Player>
            <source src="https://wiki.instar.com/videos/Speicherkarte_austauschen_bei_IN9008FullHD.mp4" />
        </Player>
        <EuiText>
            <p>Speicherkarte austauschen bei IN-9008FullHD. Auf <OutboundLink href="https://www.youtube.com/watch?v=esQdkQvb5uo" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
        </EuiText>
    </EuiPanel>
  );
}

export default VideoCard